import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoadingScreenService } from '@messaia/cdk';
import { Subscription } from "rxjs";
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-loading-screen',
    templateUrl: './loading-screen.component.html',
    styleUrls: ['./loading-screen.component.scss']
})
export class LoadingScreenComponent implements OnInit, OnDestroy {

    /**
     * loading: boolean
     */
    public loading: boolean = false;

    /**
     * loadingSubscription: Subscription
     */
    public loadingSubscription: Subscription;

    /**
     * Constructor
     * @param loadingScreenService 
     */
    constructor(private loadingScreenService: LoadingScreenService) { }

    /**
     * A callback method that is invoked immediately after the
     * default change detector has checked the directive's
     * data-bound properties for the first time,
     * and before any of the view or content children have been checked.
     * It is invoked only once when the directive is instantiated.
     */
    ngOnInit() {
        this.loadingSubscription = this.loadingScreenService.loadingStatus
            .pipe(debounceTime(50))
            .subscribe((value) => {
                this.loading = value;
            });
    }

    /**
     * A callback method that performs custom clean-up, invoked immediately
     * before a directive, pipe, or service instance is destroyed.
     */
    ngOnDestroy() {
        this.loadingSubscription.unsubscribe();
    }
}